import { useState, useEffect } from 'react';

export const useLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    // Load from localStorage
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved === 'true';
  });
  
  const [sidebarMode, setSidebarMode] = useState('push'); // 'push' | 'overlay'
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1920
  );
  
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  useEffect(() => {
    // Determine sidebar behavior based on screen size
    if (windowWidth < 768) {
      // Mobile: Overlay mode
      setSidebarMode('overlay');
    } else if (windowWidth < 1024) {
      // Tablet: Push mode, auto-collapse
      setSidebarMode('push');
      setSidebarCollapsed(true);
    } else {
      // Desktop: Push mode, use saved preference
      setSidebarMode('push');
    }
  }, [windowWidth]);
  
  const toggleSidebar = () => {
    const newState = !sidebarCollapsed;
    setSidebarCollapsed(newState);
    // Save to localStorage only on desktop
    if (windowWidth >= 1024) {
      localStorage.setItem('sidebarCollapsed', String(newState));
    }
  };
  
  return {
    sidebarCollapsed,
    sidebarMode,
    toggleSidebar,
    isMobile: windowWidth < 768,
    isTablet: windowWidth >= 768 && windowWidth < 1024,
    isDesktop: windowWidth >= 1024
  };
};

export default useLayout;

